import React, { useState, useEffect } from 'react';
import DropZone from '../components/DropZone/DropZone';
import Modal from '../components/Modal/Modal'

function TrashContainer({ recycleBins, type, isSound }) {
    const [selectedImg, setSelectedImg] = useState(null);

    return (
        <div className="trash-page">
            <div className="title-container title"><h1>{type}</h1></div>
            <div className="content">
                <DropZone recycleBins={recycleBins} type={type} setSelectedImg={setSelectedImg} isSound={isSound}/>
            </div>
            <div className="modal">
                {selectedImg && <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} isSound={isSound}/>}
            </div>
        </div>
    )
}

export default TrashContainer